import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui";
import type { ISelectOption } from "../util/options";

export interface IOptionSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  options: ISelectOption[];
  placeholder?: string;
  /** When set, prepends an "all"/clear option with this label and the ALL value. */
  allLabel?: string;
  className?: string;
  triggerClassName?: string;
  disabled?: boolean;
  id?: string;
}

/** Sentinel value used for the "all" / no-filter option (radix forbids ""). */
export const ALL_OPTION_VALUE = "__ALL__";

/** Thin wrapper over the ui `Select` that renders an `ISelectOption[]`. */
export function OptionSelect({
  value,
  onValueChange,
  options,
  placeholder,
  allLabel,
  className,
  triggerClassName,
  disabled,
  id,
}: IOptionSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className={triggerClassName ?? className} id={id} placeholder={placeholder}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {allLabel && <SelectItem value={ALL_OPTION_VALUE}>{allLabel}</SelectItem>}
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
